import { render, staticRenderFns } from "./SaidaItensListModal.vue?vue&type=template&id=0b077c2f&scoped=true"
import script from "./SaidaItensListModal.vue?vue&type=script&lang=js"
export * from "./SaidaItensListModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b077c2f",
  null
  
)

export default component.exports